module.exports = __webpack_public_path__ + "media/images/flag/flag-img-8f50282ca571c3c44471daee63d94d98.png";